import React from 'react';

const MaterialLink = ({ id, url }) => (
    <a key={id} href={url} className="d-block p-1" target="_blank">
        Attachment {id}
    </a>
);

export default MaterialLink;
